import * as React from "react";
import { Mail, Phone, Printer, User } from "lucide-react";

import { cn } from "@/shared/lib/cn";

export interface ContactInfoProps extends React.HTMLAttributes<HTMLDivElement> {
  phone1?: string | null;
  fax1?: string | null;
  email1?: string | null;
  contact1?: string | null;
}

/**
 * Stacked contact renderer (phone / fax / email / contact name), rebuilt from
 * the old `@/components/common/ContactInfo` onto shared/ui tokens. Each present
 * line is shown with a leading (decorative) icon; absent lines are omitted.
 *
 * A generic display component that forwards its ref and extra props to the
 * root element so callers can style or measure it.
 */
const ContactInfo = React.forwardRef<HTMLDivElement, ContactInfoProps>(function ContactInfo(
  { phone1, fax1, email1, contact1, className, ...props },
  ref
) {
  return (
    <div ref={ref} className={cn("flex flex-col text-sm", className)} {...props}>
      {phone1 ? (
        <span className="flex items-center gap-1">
          <Phone className="h-3 w-3 shrink-0 text-muted-foreground" aria-hidden />
          {phone1}
        </span>
      ) : null}
      {fax1 ? (
        <span className="flex items-center gap-1">
          <Printer className="h-3 w-3 shrink-0 text-muted-foreground" aria-hidden />
          {fax1}
        </span>
      ) : null}
      {email1 ? (
        <span className="flex items-center gap-1">
          <Mail className="h-3 w-3 shrink-0 text-muted-foreground" aria-hidden />
          {email1}
        </span>
      ) : null}
      {contact1 ? (
        <span className="flex items-center gap-1">
          <User className="h-3 w-3 shrink-0 text-muted-foreground" aria-hidden />
          {contact1}
        </span>
      ) : null}
    </div>
  );
});

export { ContactInfo };
